/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "@/shadcnComponents/ui/use-toast";

import LoaderOne from "@/Components/Loader";

import { SuccessPage } from "./Components/Components";
import {
  followerRangeList,
  StepperList,
  SuccessStepperList,
} from "./Helpers/Helper";
import mixpanel from "mixpanel-browser";
import { MessageLoader } from "@/Components/Loader/MessageLoader";
import { useNewCampaign } from "./CustomHooks/NewCampaignHooks";
import { CampaignInfoForm } from "./CampaignCreationForms/CampaignInfoPage";
import { InfluencerCriteriaForm } from "./CampaignCreationForms/InfluencerCriteriaForm";
import { SelectInfluencerForm } from "./CampaignCreationForms/SelectInfluencerForm";
import { ProductDetailsForm } from "./CampaignCreationForms/ProductDetailsForm";
import { CollabReviewForm } from "./CampaignCreationForms/ReviewForm";
import { PreviewCard } from "./Components/NewCampaignComponents/NewCampaignPreviewCard";
import {
  CheckOutPopupCardV2,
  CreatorSelectedPopupCardV2,
  PreviewPopUp,
} from "./Components/NewCampaignComponents/NewCampaignPreviewPopup";
import { NewCampaignCheckOutCard } from "./Components/NewCampaignComponents/NewCampaignCheckout";
import { useAuth } from "@/Providers/Auth";
import { useStaticData } from "@/Providers/Data";
import { useGeneralSettings } from "@/Providers/General";
import axios from "axios";
import { FaRegBuilding } from "react-icons/fa";
import {
  Clock,
  Handshake,
  IndianRupee,
  NotebookPen,
  Users,
} from "lucide-react";
import { isoDateToNumberDateString } from "@/Helpers/times-ago";
import { IoMdMale } from "react-icons/io";
import { NewCampaignSidebar } from "./Components/NewCampaignComponents/NewCampaignSidebar";
import { SidebarProvider } from "@/shadcnComponents/ui/sidebar";
import SampleCampaignAlert from "@/Components/Brand/RibbonAlerts/SampleAlert";
import { LocationData } from "./CampaignInterface/NewCampaignInterface";
import { SampleModeBanner } from "../../SampleCampaign/sample-mode-banner";

export const PromoteAdNewCampaign = () => {
  const { collabId } = useParams();
  const { toast } = useToast();
  const navigate = useNavigate();
  const effectRan = useRef(false);
  const authState = useAuth();
  const staticData = useStaticData();
  const generalState = useGeneralSettings();

  const {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedCreators,
    shortlistedInfluencers,
    notSelectedCreators,
    selectedPurpose,
    setSelectedPurpose,
    selectedContentCategory,
    setSelectedContentCategory,
    selectedAudienceCategory,
    setSelectedAudienceCategory,
    selectedGender,
    setSelectedGender,
    setSelectedCountry,
    selectedSeniority,
    setSelectedSeniority,
    openSelectPopup,
    openReviewPopup,
    openSuccessPage,
    currentStep,
    setCurrentStep,
    isLoading,
    setIsLoading,
    formData,
    setFormData,
    setPreviewData,
    openCheckOutPopup,
    setCollabFactors,
    setAllCredits,
    setCollabCharges,
    setCampaignCharges,
    stepValidations,
    setMasterData,
    setSelectedCreators,
    setManuallyCreators,
    setCurrentPreviewList,
    setCompletedStep,
    setNotSelectedCreators,
    sampleCampaign,
    setSampleCampaign,
    paymentProcessing,

    handleSaveData,
  } = useNewCampaign();

  useEffect(() => {
    if (authState?.loggedBrand?.activePlan) {
      setAllCredits((prev) => {
        return {
          ...prev,
          collaborationCredits:
            authState.loggedBrand.creditStats?.find(
              (item) => item.type === "Collaborations"
            )?.available || 0,
          anchorsCredits:
            authState.loggedBrand.creditStats?.find(
              (item) => item.type === "anchor Credits"
            )?.available || 0,
          campaignCredits:
            authState.loggedBrand.creditStats?.find(
              (item) => item.type === "Campaigns"
            )?.available || 0,
        };
      });
      setCollabCharges(
        sampleCampaign
          ? 0
          : authState.loggedBrand.addOn.extraCollaboration *
              generalState?.exchangeRates?.INR || 0
      );
      setCampaignCharges(
        sampleCampaign
          ? 0
          : authState.loggedBrand.addOn.additionalCampaign *
              generalState?.exchangeRates?.INR || 0
      );
    }
  }, [authState, sampleCampaign]);

  //useEffect
  useEffect(() => {
    mixpanel.track("Brand Draft Campaign Page Visited");
    async function getCollabFactors() {
      const result = await staticData?.getDataFromType("CollabFactors");
      if (result.length > 0) {
        setCollabFactors(result[0]);
      }
    }
    getCollabFactors();
  }, []); //get collab factors
  useEffect(() => {
    const fetchGoals = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await staticData?.getNewDataFromType("Goal / KPI").then((e: any) => {
          setMasterData((prev) => {
            return {
              ...prev,
              CampaignPurpose: e?.filter(
                (item) =>
                  !item?.CollabGoalsName?.includes("Sales") &&
                  !item?.CollabGoalsName?.includes("Conversions")
              ),
            };
          });
        });
      } catch (error) {
        console.log(error);
      }
    };
    const fetchAudienceTypes = async () => {
      try {
        await staticData
          ?.getNewDataFromType("lkd_super_master_audienceType")
          .then((e) => {
            setMasterData((prev) => {
              return { ...prev, AudienceType: e };
            });
          });
      } catch (error) {
        console.log(error);
      }
    };
    const fetchContentTypes = async () => {
      try {
        await staticData?.getNewDataFromType("Content Type").then((e) => {
          setMasterData((prev) => {
            return { ...prev, ContentCategory: e };
          });
        });
      } catch (error) {
        console.log(error);
      }
    };
    const fetchIndustries = async () => {
      try {
        await staticData?.getNewDataFromType("Industries").then((e) => {
          setMasterData((prev) => {
            return { ...prev, BrandIndustry: e };
          });
        });
      } catch (error) {
        console.log(error);
      }
    };
    const fetchUniqueBadges = async () => {
      try {
        await staticData?.getDataFromType("Lkd_unique_badges").then((e) => {
          setMasterData((prev) => {
            return {
              ...prev,
              uniqueBadges: e?.map((item) => item.badge),
            };
          });
        });
      } catch (error) {
        console.log(error);
      }
    };
    const fetchCreatorSize = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await staticData?.getDataFromType("creatorSize").then((e: any) => {
          setMasterData((prev) => {
            return {
              ...prev,
              creatorSize: e,
            };
          });
        });
      } catch (error) {
        console.log(error);
      }
    };
    const fetchLocationData = async () => {
      try {
        await staticData
          ?.getNewDataFromType("india-cities")
          .then((e: LocationData) => {
            setMasterData((prev) => {
              return { ...prev, locationData: e };
            });
            if (e.country) {
              setSelectedCountry(e.country);
            }
          });
      } catch (error) {
        console.log(error);
      }
    };

    const fetchCollabCompanyNames = async () => {
      try {
        await staticData
          ?.getNewDataFromType("paidAndBarterCollabCompanyNames")
          .then((e) => {
            setMasterData((prev) => {
              return { ...prev, CollabCompanyNames: e };
            });
          });
      } catch (error) {
        console.log(error);
      }
    };
    fetchGoals();
    fetchContentTypes();
    fetchIndustries();
    fetchAudienceTypes();
    fetchUniqueBadges();
    fetchCreatorSize();
    fetchLocationData();
    fetchCollabCompanyNames();
  }, []); //fetch master data
  useEffect(() => {
    if (effectRan.current) return;
    effectRan.current = true;
    if (!collabId) {
      navigate("./Brand/DashBoard/AllCampaign");
      return null;
    }
    setIsLoading(true);
    const fetchCollab = async () => {
      if (
        localStorage.getItem("jwtToken") &&
        localStorage.getItem("UserType").toLocaleLowerCase() === "brand"
      ) {
        try {
          const host = import.meta.env.VITE_BACKEND_SERVER_URL;
          const res = await axios.get(
            `${host}/collabs/brand/getCollab/?collabId=${collabId}`,
            {
              headers: {
                jwtToken: localStorage.getItem("jwtToken"),
              },
            }
          );

          if (res?.status === 200 && res?.data?.success) {
            const collab = res?.data?.collab;

            const followers =
              collab?.shortlistingCriteria?.influencerCriteria?.followers?.[0]?.split(
                "-"
              );

            setFormData({
              ...formData,
              campaignInfo:
                collab?.campaignInfo || formData?.campaignInfo || {},
              collabInfo:
                collab?.shortlistingCriteria?.collabCriteria ||
                formData?.collabInfo ||
                {},
              creatorInfo: {
                ...collab?.shortlistingCriteria?.influencerCriteria,
                minCreatorFollowers: followers?.[0] || followerRangeList.min[1],
                maxCreatorFollowers:
                  collab?.shortlistingCriteria?.influencerCriteria
                    ?.followers?.[1] === "More than 100k"
                    ? "More than 100k"
                    : followers?.[1] || followerRangeList.max[0],
              },
              Budget: collab?.Budget || formData?.Budget || {},
              productInfo: collab?.productInfo || formData?.productInfo || {},
              postInfo: collab?.postInfo || formData?.postInfo || {},
            });
            setSampleCampaign(collab?.campaignInfo?.isSampleCampaign);
            setSelectedPurpose(
              collab?.shortlistingCriteria?.collabCriteria?.collabPurpose || []
            );
            setSelectedContentCategory(
              collab?.shortlistingCriteria?.influencerCriteria
                ?.contentCategory || []
            );
            setSelectedSeniority(
              collab?.shortlistingCriteria?.influencerCriteria?.seniority || []
            );
            setSelectedAudienceCategory(
              collab?.shortlistingCriteria?.influencerCriteria
                ?.audienceCategory || []
            );

            setSelectedGender(
              collab?.shortlistingCriteria?.influencerCriteria?.gender || []
            );
            setStartDate(collab?.campaignInfo?.campaignStartDate);
            setEndDate(collab?.campaignInfo?.campaignEndDate);
            setCurrentStep(collab?.currentStep || 1);
            setSelectedCreators([
              ...(collab?.influencerSelection?.selectedInfluencers || []),
              ...(collab?.influencerSelection?.manuallySelectedInfluencers ||
                []),
            ]);
            setManuallyCreators(
              collab?.influencerSelection?.manuallySelectedInfluencers
            );
            setPreviewData((prev) => {
              return {
                ...prev,
                numberOfInfluencers: collab?.ROI?.expectedNumberOfInfluencers,
                minImpressions: collab?.ROI?.expectedTotalImpression?.min,
                maxImpressions: collab?.ROI?.expectedTotalImpression?.max,
                collabCPI: collab?.ROI?.collabCPI,
              };
            });
            effectRan.current = false;
            setIsLoading(false);
          }
        } catch (error) {
          console.log(error);
          setIsLoading(false);
          effectRan.current = false;
          toast({
            title: "Failed to fetch campaign details",
            variant: "destructive",
          });
          navigate("/Brand/DashBoard/AllCampaign");
        }
      }
    };

    if (collabId !== "sample") {
      fetchCollab();
    } else {
      setFormData({
        ...formData,
        campaignInfo: {
          ...formData.campaignInfo,
          campaignName: "Sample Campaign",
          collabType: "performance",
        },
      });

      effectRan.current = false;
      setIsLoading(false);
      setCurrentStep(1);
      toast({
        title: "This is a sample campaign",
        variant: "default",
      });
    }
  }, [collabId]); //fetch current collab
  useEffect(() => {
    if (effectRan.current) return;
    handleSaveData({ isAddMore: false });
  }, [
    formData?.campaignInfo?.campaignName,
    formData?.collabInfo?.collabPurpose,
    formData?.collabInfo?.collabGoals,
    formData?.collabInfo?.collabPlatform,
    formData?.collabInfo?.collabIndustry,
    formData?.collabInfo?.collabBuisnessType,
    formData?.creatorInfo?.contentCategory,
    formData?.creatorInfo?.audienceCategory,
    formData?.creatorInfo?.seniority,
    formData?.creatorInfo?.minCreatorFollowers,
    formData?.creatorInfo?.maxCreatorFollowers,
    formData?.creatorInfo?.isPastCollabs,
    formData?.creatorInfo?.gender,
    formData?.postInfo?.postDrafts?.[0]?.postFormat,
    formData?.Budget?.minBillAmount,
    formData?.Budget?.maxBillAmount,
    startDate,
    endDate,
  ]); //save data on every change
  useEffect(() => {
    if (selectedPurpose) {
      setFormData({
        ...formData,
        collabInfo: { ...formData.collabInfo, collabPurpose: selectedPurpose },
      });
    }
  }, [selectedPurpose]);
  useEffect(() => {
    if (selectedContentCategory) {
      setFormData({
        ...formData,
        creatorInfo: {
          ...formData.creatorInfo,
          contentCategory: selectedContentCategory,
        },
      });
    }
  }, [selectedContentCategory]);
  useEffect(() => {
    if (selectedAudienceCategory) {
      setFormData({
        ...formData,
        creatorInfo: {
          ...formData.creatorInfo,
          audienceCategory: selectedAudienceCategory,
        },
      });
    }
  }, [selectedAudienceCategory]);
  useEffect(() => {
    if (selectedGender) {
      setFormData({
        ...formData,
        creatorInfo: {
          ...formData.creatorInfo,
          gender: selectedGender,
        },
      });
    }
  }, [selectedGender]);
  useEffect(() => {
    if (selectedSeniority) {
      setFormData({
        ...formData,
        creatorInfo: {
          ...formData.creatorInfo,
          seniority: selectedSeniority,
        },
      });
    }
  }, [selectedSeniority]);
  useEffect(() => {
    const doc = document.getElementById(`campaignFormBox`);
    doc?.scrollIntoView({ behavior: "smooth" });
    async function getShortListedInfluencer() {
      setIsLoading(true);
      await handleSaveData({ isAddMore: false, isRefresh: true });
      setIsLoading(false);
    }
    if (currentStep === 3) {
      getShortListedInfluencer();
    }
  }, [currentStep]); //Auto Scroll to top in each step and get shortlisted influencer in step 3

  useEffect(() => {
    const validateSteps = () => {
      const newCompletedSteps = new Set();

      Object.entries(stepValidations).forEach(([step, validator]) => {
        if (validator()) {
          newCompletedSteps.add(parseInt(step));
        }
      });

      return Array.from(newCompletedSteps).sort();
    };

    setCompletedStep(validateSteps());
  }, [formData, selectedCreators, startDate, endDate, openSuccessPage]);

  useEffect(() => {
    if (shortlistedInfluencers?.length > 0) {
      setSelectedCreators(
        shortlistedInfluencers
          ?.map((item) =>
            selectedCreators?.includes(item?._id)
              ? // ||
                //   selectedCreators?.find((creator) => creator?._id === item?._id)
                item?._id
              : undefined
          )
          ?.filter((item) => item)
      );
    }
  }, [shortlistedInfluencers]); //set selected creators after each shortlisted creators
  useEffect(() => {
    if (currentStep === 3) {
      let oldNotSelectedCreators = notSelectedCreators;
      const newNotSelectedCreators = shortlistedInfluencers
        ?.map((item) =>
          !selectedCreators?.includes(item?._id) ? item : undefined
        )
        ?.filter((item) => item);
      // Merge the arrays and remove duplicates
      oldNotSelectedCreators = [].concat(
        ...[newNotSelectedCreators, oldNotSelectedCreators]
      );
      oldNotSelectedCreators = Array.from(
        oldNotSelectedCreators
          .reduce((map, obj) => map.set(obj["_id"], obj), new Map())
          .values()
      );
      oldNotSelectedCreators = oldNotSelectedCreators?.filter(
        (item) => !selectedCreators?.includes(item?._id)
      );
      setNotSelectedCreators(oldNotSelectedCreators);
    }
  }, [selectedCreators]); // set non selected creators on 3rd step
  useEffect(() => {
    if (currentStep === 1) {
      setCurrentPreviewList([
        {
          title: "Industry Area",
          value: formData?.collabInfo?.collabIndustry,
          bg: "bg-green-400",
          icon: <FaRegBuilding color="#000000" size={24} />,
        },
        {
          title: "Business",
          value: formData?.collabInfo?.collabBuisnessType?.toUpperCase(),
          bg: "bg-red-400",
          icon: <FaRegBuilding color="#000000" size={24} />,
        },
        {
          title: "Budget Range",
          value: `₹${formData?.Budget?.minBillAmount?.toLocaleString()} - ₹${formData?.Budget?.maxBillAmount?.toLocaleString()}`,
          bg: "bg-yellow-400",
          icon: <IndianRupee color="#000000" size={24} />,
        },
        {
          title: "Expected Go-Live Range",
          value: `${isoDateToNumberDateString(
            startDate?.toString()
          )} - ${isoDateToNumberDateString(endDate?.toString())}`,
          bg: "bg-blue-400",
          icon: <Clock color="#000000" size={24} />,
        },
      ]);
    }
    if (currentStep === 2) {
      setCurrentPreviewList([
        {
          title: "Gender",
          value: formData?.creatorInfo?.gender || "-",
          bg: "bg-green-400",
          icon: <IoMdMale color="#000000" size={24} />,
        },
        {
          title: "Follower Range",
          value: `${formData?.creatorInfo?.minCreatorFollowers} - ${formData?.creatorInfo?.maxCreatorFollowers}`,
          bg: "bg-red-400",
          icon: <Users color="#000000" size={24} />,
        },
        {
          title: "Past Collaborations",
          value: `${formData?.creatorInfo?.isPastCollabs || `-`}`,
          bg: "bg-yellow-400",
          icon: <Handshake color="#000000" size={24} />,
        },
        {
          title: "Post Format",
          value: `${formData?.postInfo?.postDrafts?.[0]?.postFormat
            ?.replace("/", "+")
            ?.replace("text", "Text")
            ?.replace("image", "Image")}`,
          bg: "bg-blue-400",
          icon: <NotebookPen color="#000000" size={24} />,
        },
      ]);
    }
  }, [formData, currentStep, startDate, endDate]); // set the data to show in toaster in each step

  return (
    <>
      {openSelectPopup && <CreatorSelectedPopupCardV2 closable />}
      {openCheckOutPopup && <CheckOutPopupCardV2 />}

      {effectRan.current ? (
        <LoaderOne />
      ) : (
        <SidebarProvider className="bg-white">
          <div className="flex w-full min-h-full font-inter bg-[#FFFFFF] ">
            <NewCampaignSidebar List={StepperList} />

            {/*Campaign Form*/}
            {openSuccessPage ? (
              <SuccessPage
                SuccessStepperList={SuccessStepperList}
                navigateTo={() => {
                  if (collabId === "sample") {
                    navigate("/Brand/DashBoard/AllCampaign/Campaign/sample/");
                  } else {
                    navigate("/Brand/DashBoard/AllCampaign/?section=Review");
                  }
                }}
              />
            ) : (
              <>
                {openReviewPopup && <PreviewPopUp closable />}

                {(isLoading || paymentProcessing) && (
                  <MessageLoader className="h-screen" />
                )}
                <div
                  id="campaignFormBox"
                  className={`flex h-auto gap-4 p-4 bg-[#F7F9FE] flex-1 items-start justify-center py-5 mb-5 ${
                    isLoading || paymentProcessing ? "hidden" : ""
                  } `}
                >
                  <div className="flex w-[75%] items-start flex-col justify-around gap-8">
                    {collabId === "sample" && <SampleCampaignAlert />}
                    {formData?.campaignInfo?.isSampleCampaign && (
                      <SampleModeBanner />
                    )}

                    {currentStep === 1 && <CampaignInfoForm />}
                    {currentStep === 2 && <InfluencerCriteriaForm />}
                    {currentStep === 3 && <SelectInfluencerForm />}
                    {currentStep === 4 && <ProductDetailsForm />}
                    {currentStep === 5 && <CollabReviewForm />}
                    {currentStep === 6 && <NewCampaignCheckOutCard />}
                  </div>

                  {[2, 3, 5]?.includes(currentStep) && (
                    <div className="w-[25%]">
                      <PreviewCard />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </SidebarProvider>
      )}
    </>
  );
};
